module.exports = __webpack_public_path__ + "static/deployment-8e856cefe94768006d66885170c7df8a.svg";